import mime from 'mime/lite';
export var getFileNameFromURL = function getFileNameFromURL(file) {
  if (file.url) {
    var cleanURL = file.url.split(/[?#]/)[0];
    return cleanURL.substring(cleanURL.lastIndexOf('/') + 1);
  }
  return '';
};
export var getFileName = function getFileName(file) {
  if (file.filename) {
    return file.filename;
  }
  if (file.url) {
    return getFileNameFromURL(file);
  }
  return '';
};
export var getFileExtension = function getFileExtension(file) {
  if (file.filetype) {
    return mime.getExtension(file.filetype);
  }
  var filetype = mime.getType(getFileName(file));
  if (!filetype) {
    filetype = mime.getType(getFileNameFromURL(file));
  }
  if (filetype) {
    return mime.getExtension(filetype);
  }
  return 'unsupported';
};
export var isImage = function isImage(file) {
  var extension = getFileExtension(file);
  var extensions = ['jpg', 'jpeg', 'png', 'gif', 'svg'];
  return extensions.includes(extension);
};
export var formatBytes = function formatBytes(bytes, decimals) {
  if (decimals === void 0) {
    decimals = 2;
  }
  if (bytes === 0) return '0 Bytes';
  var k = 1024;
  var dm = decimals < 0 ? 0 : decimals;
  var sizes = ['Bytes', 'KB', 'MB'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return "" + parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
};